import React from 'react';
import { Card } from '@/components/ui/card';
import { ROLE_LABELS } from '@/lib/constants';
import { CalendarRange } from 'lucide-react';

export default function WeekendBalance({ stats }) {
  const rows = (stats?.weekend_balance || []).filter((r) => r.role !== 'veduca' || r.this_month > 0);
  if (!rows.length) return null;

  return (
    <Card className="p-4" data-testid="weekend-balance-card">
      <div className="flex items-center gap-2 mb-3">
        <CalendarRange className="w-4 h-4 text-slate-500" />
        <h3 className="text-sm font-semibold text-slate-700">Rotácia víkendov (cyklus naprieč mesiacmi)</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs" data-testid="weekend-balance-table">
          <thead>
            <tr className="text-slate-400 text-left border-b border-slate-100">
              <th className="pb-1.5 font-medium">Zamestnanec</th>
              <th className="pb-1.5 font-medium text-right" title="Prenos víkendových dní z minulých mesiacov">Prenos</th>
              <th className="pb-1.5 font-medium text-right" title="Odpracované víkendové dni tento mesiac">Tento mesiac</th>
              <th className="pb-1.5 font-medium text-right" title="Kumulatívne spolu (základ ďalšej rotácie)">Spolu</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`weekend-row-${r.id}`} className="border-b border-slate-50 last:border-0">
                <td className="py-1.5">
                  <div className="font-medium text-slate-700">{r.name}</div>
                  <div className="text-[10px] text-slate-400">{ROLE_LABELS[r.role] || r.role}</div>
                </td>
                <td className="py-1.5 text-right font-mono text-slate-500">{r.carry_in || 0}</td>
                <td className="py-1.5 text-right font-mono text-teal-700 font-semibold">{r.this_month}</td>
                <td className="py-1.5 text-right font-mono text-slate-700">{r.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-slate-400 mt-3 leading-relaxed">
        Celé víkendy (So+Ne tej istej osobe) sa férovo striedajú a prenášajú do ďalšieho mesiaca – cyklus pokračuje. Sobota 3 osoby, nedeľa 2 (1 zo sobotných má už voľno).
      </p>
    </Card>
  );
}
